import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivSupplementBox = styled.div`
  display: flex;
  align-items: center;
  color: ${COLOR.GRAY900.code};
  font-size: ${FONT_SIZE.S}px;
`;

export const SpanText = styled.span`
  font-size: ${FONT_SIZE.S}px;
  color: ${COLOR.RED900.code};
`;

export const Anchor = styled.a`
  color: ${COLOR.BLUE900.code};
`;
